import {makeSignUpConfirm} from 'main/factories/usecases';
import {SignUpConfirmParams} from './types';

export async function signUpConfirm({signal, ...confirmParams}: SignUpConfirmParams) {
	const response = await makeSignUpConfirm().signUpConfirm({signal, ...confirmParams});

	return response;
}
